<nav>
  <p-megamenu #megaMenuRef [model]="navigationItems" orientation="horizontal">
    <ng-template #start>
      <a class="mb-2" href="#">
       <img [src]="logoUrl()" alt="Logo" class="m-2" class="logo"/>
      </a>
      <a [href]="legacyFrontendURL" pButton target="_blank" rel="noopener">
        <i class="pi pi-external-link" pButtonIcon></i>
        <span pButtonLabel i18n="navigation|Link to old user interface">Old UI</span>
      </a>
    </ng-template>
    <ng-template #userInfoTable>
      <table>
        <tr>
          <th i18n="navigation|user info">Name</th>
          <td>{{ currentUser?.firstname }} {{ currentUser?.lastname }}</td>
        </tr>
        <tr>
          <th i18n="navigation|user info">Email</th>
          <td><a href="mailto:{{ currentUser?.email }}">{{ currentUser?.email }}</a></td>
        </tr>
        <tr>
          <th i18n="navigation|user info">Client number</th>
          <td>{{ formattedClientNumber() }}</td>
        </tr>
        <tr>
          <th i18n="navigation|user info">Company</th>
          <td>{{ currentUser?.company }}</td>
        </tr>
      </table>
    </ng-template>
    <ng-template #item let-item>
      @if (item.isImpersonationItem) {
        <p-card class="user-info-card" header="Acting as">
          <ng-container *ngTemplateOutlet="userInfoTable"></ng-container>
          <p-button i18n-label="impersonation|Stop impersonation button" label="Stop acting as different user" (onClick)="stopImpersonation()" icon="pi pi-user"></p-button>
        </p-card>
      } @else if (item.isUserDataItem) {
        <p-card class="user-info-card" header="Signed in as">
          <ng-container *ngTemplateOutlet="userInfoTable"></ng-container>
        </p-card>
      } @else if (!this.isRoutingItem(item)) {
        <a pRipple class="p-megamenu-item-link">
          @if (item.icon) {
            <i [class]="item.icon"></i>
          }
          <span class="m1-2">{{ item.label }}</span>
          @if (item.icon) {
            <span [class]="item.icon"></span>
          }
          @if (item.items) {
            <span class="p-megamenu-submenu-icon pi pi-angle-down"></span>
          }
        </a>
      } @else if (item.routerLink) {
        <a pRipple class="p-megamenu-item-link"
          [routerLink]="item.routerLink"
          [attr.href]="item.url"
          [attr.target]="item.target"
          (click)="item.command && item.command($event)"
          [attr.tabindex]="item.disabled ? -1 : (item.tabindex ? item.tabindex : null)"
          [attr.aria-disabled]="item.disabled">
          @if (item.icon) {
            <span [class]="item.icon"></span>
          }
          <span class="p-megamenu-item-label">{{ item.label }}</span>
          @if (item.items) {
            <span class="p-megamenu-submenu-icon pi pi-angle-down"></span>
          }
        </a>
      } @else {
        <a pRipple class="p-megamenu-item-link"
          [attr.href]="item.url"
          [attr.target]="item.target"
          (click)="item.command && item.command($event)"
          [attr.tabindex]="item.disabled ? -1 : (item.tabindex ? item.tabindex : null)"
          [attr.aria-disabled]="item.disabled">
          @if (item.icon) {
            <span [class]="item.icon"></span>
          }
          <span class="p-megamenu-item-label">{{ item.label }}</span>
          @if (item.items) {
            <span class="p-megamenu-submenu-icon pi pi-angle-down"></span>
          }
        </a>
      }
    </ng-template>
    <ng-template #end>
      <div class="flex flex-row gap-3">
        <app-language-switcher></app-language-switcher>
        <div class="p-megamenu-item-content" data-pc-section="content">
          <a class="nav-link" [routerLink]="['/cart']">Cart ({{ cartService.cartSize() }})</a>
        </div>
      </div>
    </ng-template>
  </p-megamenu>
</nav>
